"use strict";
/**
 * MHub Message class.
 */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Message to be sent or received over MHub network.
 */
var Message = /** @class */ (function () {
    /**
     * Construct message object.
     *
     * Note: headers are cloned, but data is NOT cloned, so don't change data after you've
     * passed it to the pubsub framework!
     */
    function Message(topic, data, headers) {
        this.topic = topic;
        this.data = data;
        this.headers = __assign({}, headers); // clone
    }
    /**
     * Create a Message object from a plain object, by taking its topic, data and
     * headers properties.
     *
     * Note that the data is not deep-cloned.
     *
     * @param o Input object. Must at least contain a `.topic` property.
     * @return New `Message` instance, with given topic, same data, and clone of headers.
     */
    Message.fromObject = function (o) {
        if (!o || typeof o !== "object") {
            throw new TypeError("cannot create message from object, got " + typeof o);
        }
        return new Message(o.topic, o.data, o.headers);
    };
    /**
     * Perform a shallow clone of the message.
     *
     * I.e. the new message will share the same `data` as the source message,
     * so be careful when the data is an object: making changes to it will be
     * reflected in the old and new message.
     *
     * The headers (if any) are cloned into a new headers object.
     *
     * @return New message with same topic, same data and shallow clone of headers.
     */
    Message.prototype.clone = function () {
        return new Message(this.topic, this.data, this.headers);
    };
    /**
     * Validate correctness of message properties, e.g. that topic is a string,
     * and header is either undefined or key-values.
     */
    Message.prototype.validate = function () {
        if (typeof this.topic !== "string") {
            throw new TypeError("invalid topic: expected string, got " + typeof this.topic);
        }
        var headers = this.headers;
        if (headers !== undefined && typeof headers !== "object") {
            throw new TypeError("invalid headers: expected object or undefined, got " + typeof headers);
        }
        for (var key in headers) {
            if (!headers.hasOwnProperty(key)) {
                continue;
            }
            var t = typeof headers[key];
            if (t !== "string" && t !== "boolean" && t !== "number") {
                throw new TypeError("invalid headers: expected string, boolean or number for header '" + key + "', got " + t);
            }
        }
    };
    return Message;
}());
exports.Message = Message;
exports.default = Message;
//# sourceMappingURL=message.js.map